export default __webpack_public_path__ + "static/media/turn-right.1c508c64.svg";